import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const CareSearch = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="care search icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1ZM0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5C17 10.72 16.1489 12.7413 14.7552 14.2552L15.9018 15.4018L16.2731 15.0305C16.6637 14.6399 17.2968 14.6399 17.6874 15.0305L23.523 20.8662C23.9136 21.2567 23.9136 21.8898 23.523 22.2804L22.1088 23.6946C21.7183 24.0851 21.0851 24.0851 20.6946 23.6946L14.8589 17.8589C14.4684 17.4684 14.4684 16.8352 14.8589 16.4447L15.1947 16.1089L14.036 14.9502C12.5487 16.2279 10.6145 17 8.5 17C3.80558 17 0 13.1944 0 8.5ZM15.566 17.1518L16.9803 15.7376L22.8159 21.5733L21.4017 22.9875L15.566 17.1518ZM6.75 4C7.45611 4 8.04158 4.21814 8.49984 4.54399C8.95817 4.21814 9.54372 4 10.25 4C12.3052 4 13.4913 5.81451 13.5 7.49482L13.5 7.5C13.5 8.39267 13.1448 9.19263 12.7049 9.847C12.2626 10.5048 11.6919 11.08 11.153 11.5448C10.6101 12.013 10.0721 12.3925 9.67224 12.654C9.44683 12.8015 9.21812 12.9458 8.98214 13.076C8.75 13.205 8.2857 13.2235 8.01785 13.0762C7.9523 13.0402 7.91389 13.0203 7.88435 13.005L7.88427 13.005C7.79317 12.9578 7.78637 12.9543 7.32736 12.654C6.92752 12.3924 6.38955 12.0129 5.84675 11.5447C5.30793 11.08 4.73726 10.5048 4.29505 9.84696C3.85516 9.19258 3.5 8.39264 3.5 7.5L3.50001 7.49499C3.50843 5.81414 4.69499 4 6.75 4ZM4.5 7.5C4.50649 6.20386 5.39742 5 6.75 5C7.15625 5 7.49974 5.10431 7.7809 5.26879C8.10121 5.45617 8.34063 5.72166 8.49979 6C8.65899 5.72168 8.89841 5.45622 9.21873 5.26884C9.49997 5.10433 9.84356 5 10.25 5C11.6025 5 12.4933 6.20405 12.5 7.5C12.5 10 8.49979 12.2 8.49979 12.2C8.49979 12.2 4.5 10 4.5 7.5Z"
    />
  </svg>
)
